import React, { useState, useContext, useEffect } from 'react';
import { Input, AutoComplete } from 'antd';
import { ThemeContext } from '../Context/ThemeContext';
import { ExploreContext } from '../Context/ExploreContext';

const SearchBar = (props) => {
  const { theme } = useContext(ThemeContext);
  const { searchContent, fetchSearchResults } = useContext(ExploreContext);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    /* eslint-disable no-unused-expressions */
    setOptions([
      {
        label: renderTitle('Updates'),
        options: searchContent.results.articles.map((article) => {
          return renderItem(article);
        }),
      },
    ]);
  }, [searchContent.results.articles]);

  const renderTitle = (title) => {
    return (
      <span>
        <b>{title}</b>
      </span>
    );
  };

  const renderItem = (update) => {
    return {
      value: update.description,
      label: (
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <a href={`/updates/${update.uid}`} rel='noopener noreferrer'>
            {update.description.substring(0, 30)}{' '}
            {update.description.length > 30 ? '...' : ''}
          </a>
          <span
            style={{
              float: 'right',
            }}
          >
            {update.views}&nbsp;{update.views === 1 ? 'view' : 'views'}
          </span>
        </div>
      ),
    };
  };

  const handleSearch = (value) => {
    fetchSearchResults(value);
  };

  const onSelect = (value) => {
    console.log('onSelect', value);
  };

  return (
    <div>
      <AutoComplete
        dropdownMatchSelectWidth={252}
        style={{ width: '100%' }}
        options={options}
        onSelect={onSelect}
        onSearch={handleSearch}
      >
        <Input.Search
          size='large'
          placeholder='Search Public Updates'
          enterButton
        />
      </AutoComplete>
    </div>
  );
};

export default SearchBar;
